import React, { useState, useRef, useEffect } from 'react'

const calculateTime = (secs) => {
  const minutes = Math.floor(secs / 60);
  const seconds = Math.floor(secs % 60);
  const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
  return `${minutes}:${returnedSeconds}`;
}


export const AudioPlayer = (props) => {
	
	// const seekBar = useRef();
	// const seekPosition = useRef();
	const seekSlider 	= useRef();
	const volSlider = useRef();
	const zedAudioPlayer = useRef();
	let [ playState, setPlayState ] = useState('pause')
	let [ muted, setMuted ]= useState(false)
	let [ duration, setDuration ]= useState(Infinity)
	let [ position, setPosition ]= useState(0)
	let [ volume, setVolume ]= useState(100)
	let [ seek, setSeek ]= useState(0)

	useEffect( () => {
		if(props.audio) {
			console.log('props.audio')
			props.audio.addEventListener('loadedmetadata', () => {
				// console.log('got a change');
				// console.log(props.audio.duration);
				setDuration(props.audio.duration)
			});
			props.audio.addEventListener('play', () => {
				setPlayState('play')
				console.log('event play')
				// seekSlider.value = Math.floor(props.audio.currentTime);
			});
		
		
			props.audio.addEventListener('pause', () => {
				setPlayState('pause')
				console.log('event pause')
				// seekSlider.value = Math.floor(props.audio.currentTime);
			});
		
			props.audio.addEventListener('canplay', () => {
				// setPlayState('play')
				console.log('event canplay')
				// seekSlider.value = Math.floor(props.audio.currentTime);
			});
	
			props.audio.addEventListener('timeupdate', () => {
				setPosition(Math.floor(props.audio.currentTime));
				// const width = seekBar.current.offsetWidth;
				// seekPosition.current.style.left = Math.floor(props.audio.currentTime / props.audio.duration * width)
				if (props.audio.duration === Infinity || props.audio.duration === 0)
				{
					// console.log(props.audio,duration);
				} else {
					// console.log(props.audio,duration);
					displayBufferedAmount(props.audio);
					setSeek(Math.floor(props.audio.currentTime / props.audio.duration));
				}
			});
		}
		

	}, [props.audio] )

	// props.audio && props.audio.addEventListener('loadedmetadata', () => {
	// 	// console.log('got a change');
	// 	// console.log(props.audio.duration);
	// 	setDuration(props.audio.duration)
	// });

	const displayBufferedAmount = (audio) => {
		if(seekSlider.current) {
			const bufferedAmount = Math.floor(audio.buffered.end(audio.buffered.length - 1));
			zedAudioPlayer.current.style.setProperty('--buffered-width', `${(bufferedAmount / seekSlider.current.max) * 100}%`);
		}
	}





	const volumeChange = (ev) => {
		const value = ev.target.value;
		props.audio.volume = value / 100;
		setVolume(value);
	}

	const mute = () => {
		if (muted) { 
			props.audio.muted = false;
		}
		else {
			props.audio.muted = true;
		}
		setMuted(!muted);
	}

	const seekChange = (ev) => {
		const value = ev.target.value;
		props.audio.currentTime = value;
		setPosition(value);
		console.log(props.audio	)
	}

	const play = () => {
		props.audio.play();
		setPlayState('play')
		console.log('button play')
	}

	const pause = () => {
		props.audio.pause();
		if (props.audio,duration === Infinity || props.audio.duration === 0) {
			console.log('infinite!')
			props.audio.currentTime = 0;
			props.audio.load();
		}
		setPlayState('pause')
		console.log('button pause')

		// props.audio.reload(true );
	}

	return (
		<div id="zed-audio-player" ref={zedAudioPlayer}>
			{ playState === 'pause' && <button style={{fontFamily: "FontAwesome"}} onClick={play} type="button" aria-live="polite" title="Play" aria-disabled="false"></button> }
			{ playState === 'play' && <button style={{fontFamily: "FontAwesome"}} onClick={pause} type="button" aria-live="polite" title="Pause" aria-disabled="false"></button> }
			{ duration !== Infinity ?
				<React.Fragment>
					<span id="current-time" className="time">{calculateTime(position)}</span>
					{/* <span ref={seekBar} style={{ width: '240px', display: 'inline-block' }}><span style={{ position: 'relative', left: seek }} ref={seekPosition}>|</span></span> */}
					<input onChange={seekChange} ref={seekSlider} type="range" id="seek-slider" max={duration} value={position}></input>
					<span id="duration" className="time">{calculateTime(duration)}</span>
				</React.Fragment> :
				<span className="time">LIVE</span>
			}
			<div className="volume-wrapper">
			
				<button onClick={mute} id="mute-icon">{ muted ? '' : '' }</button>
				<input onChange={volumeChange} ref={volSlider} type="range" id="volume-slider" max="100" value={volume} />
				<span id="volume-ammount" className="time">{volume}</span>
			</div>
		</div>
	)
}